//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AvatarDisplay from '@/components/ui/AvatarDisplay'

export default {
  name: 'KothItem',
  components: {
    AvatarDisplay
  },
  props: {
    linkToFreelancer: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      avatarOptions: {
        resize: {
          width: 500,
          height: 400
        }
      }
    }
  },
  async fetch () {
    await this.$store.dispatch('freelancers/setInitialKoth')
  },
  computed: {
    koth () {
      return this.$store.state.freelancers.koth
    },

    avatar () {
      return this.koth?.freelancer?.avatar
    },

    name () {
      return this.koth?.freelancer?.name
    },

    occupation () {
      return this.koth?.freelancer?.occupation
    },

    link () {
      return !this.linkToFreelancer ? '/koth' : '/freelancers/' + this.koth?.freelancer?.slug + '/' + this.koth?.freelancer?.id
    }
  }
}
